var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"station-map"},[_c('top-bar',[_vm._v("Bahnhofsplan")]),_vm._v(" "),_c('iframe',{attrs:{"width":"100%","height":"100%","src":_vm.iFrameSrc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }